import PopupV1 from './v1';
import PopupV2 from './v2';
import { POPUP_TYPE } from './constant';

export {
  PopupV1,
  PopupV2,
  POPUP_TYPE,
};

export default PopupV1;
